class Tabs {
    constructor() {
        this.navElements = document.querySelectorAll('.js-quick-navigation a');
        this.targets = [];

        for (let i = 0; i < this.navElements.length; i++) {
            let selector = this.navElements[i].getAttribute('href');
            let element = document.querySelector(selector);

            if (element) {
                this.targets.push(element);
            }
        }
    }

    init() {
        const _navElements = this.navElements;
        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    _navElements.forEach(element => element.parentElement.classList.remove('is-active'));
                    let navElement = document.querySelector('[href="#' + entry.target.id + '"]')
                    navElement.parentElement.classList.add('is-active');
                    //navElement.scrollIntoView();

                }
            });

        }, {
            threshold: 0.4
        });

        this.targets.forEach(target => observer.observe(target));
    }
}

export default new Tabs();
